import { IState } from 'legacy/lut/store'

import { selectWelcomeFlowState } from './selectWelcomeFlowState'

export const selectIsFetching = (state: IState) => selectWelcomeFlowState(state).isFetching
